export default "__VITE_ASSET__Bkvk4W0X__"